import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type Survey } from './useSurveyForSettingsQuery'
import { useSurveyForSettingsQueryKey } from './useSurveyForSettingsQueryKey'

export const useSurveyForSettingsQueryData = () => {
  const queryKey = useSurveyForSettingsQueryKey()
  const { data } = useQuery<Survey | undefined>({ enabled: false, queryKey })

  return React.useMemo(() => data, [data])
}
